import { hexWithAlphaToRgba } from "../lib/utils";
import { Layer } from "../types/Editor";
import { interpolate, useCurrentFrame, useVideoConfig } from "remotion";

interface HighlightEffectProps {
  layer: Layer;
}

export const HighlightEffect: React.FC<HighlightEffectProps> = ({ layer }) => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const startFrame = 0;
  const introEndFrame =
    layer.introDuration > 0 ? layer.introDuration * fps : startFrame + 1; // Ensure it's at least 1 frame ahead
  const mainEndFrame =
    introEndFrame + (layer.mainDuration > 0 ? layer.mainDuration * fps : 1); // Ensure it's at least 1 frame ahead
  const outroEndFrame =
    mainEndFrame + (layer.outroDuration > 0 ? layer.outroDuration * fps : 1); // Ensure it's at least 1 frame ahead

  const opacity = interpolate(
    frame,
    [startFrame, introEndFrame, mainEndFrame, outroEndFrame],
    [0, 1, 1, 0],
    {
      extrapolateLeft: "clamp",
      extrapolateRight: "clamp",
    }
  );

  const defaultColor = "#000000";
  const color = hexWithAlphaToRgba(layer.data.color || defaultColor, layer.data.transparency / 100);

  return (
    <div style={{ position: "absolute", width: "100%", height: "100%", overflow: "hidden" }}>
      {/* 
        Seamless mask using a single div and a huge box-shadow. 
        This eliminates sub-pixel gaps (hairlines) caused by rendering multiple adjacent divs.
      */}
      <div
        style={{
          position: "absolute",
          top: `${layer.data.y * 100}%`,
          left: `${layer.data.x * 100}%`,
          width: `${layer.data.width * 100}%`,
          height: `${layer.data.height * 100}%`,
          boxShadow: `0 0 0 5000px ${color}`,
          opacity,
          pointerEvents: "none",
        }}
      />
    </div>
  );
};
